import React, { Component } from 'react';
import FbrService from '../service/FbrService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { SplitButton } from 'primereact/splitbutton';
import { Calendar } from 'primereact/calendar';
import { ProgressSpinner } from 'primereact/progressspinner';
import 'moment/locale/fr';
import moment from 'moment';
 
export class FormStatRapportagePrest extends Component {
    constructor() {
        super();
        this.state = {
            pd1:  new Date(moment(new Date()).format('YYYY') + '-01-01'),
            pd2: new Date(),
            rRegion: null,
            rPref: null,
            rCrd: null,
            liste_data: [],
            liste_region: [],
            liste_all_pref: [],
            liste_pref: [],
            liste_all_crd: [],
            liste_crd: [],
            items: [
                {
                    label: 'Format PDF',
                    icon: 'pi pi-print',
                    command: (e) => {
                        this.conf_print('PDF');
                    }
                },
                {
                    label: 'Format XLS',
                    icon: 'pi pi-print',
                    command: (e) => {
                        this.conf_print('XLS');
                    }
                },
                {
                    label: 'Format CSV',
                    icon: 'pi pi-print',
                    command: (e) => {
                        this.dt.exportCSV();
                    }
                }
            ],
            showindicator: false,
            userconnected: JSON.parse(localStorage.getItem('userconnected')),
        };
        this.conf_print = this.conf_print.bind(this);
        this.FbrService = new FbrService();
    }


    conf_print(format) {
        let spd1 = moment(this.state.pd1).format('MM/YYYY');
        let spd2 = moment(this.state.pd2).format('MM/YYYY');
        let region = 'Tous';
        let pref = 'Tous';
        let crd = 'Tous';
        if (this.state.rCrd !== undefined && this.state.rCrd !== null) {
            crd = this.state.rCrd;
        }
        if (this.state.rRegion !== undefined && this.state.rRegion !== null) {
            region = this.state.rRegion;
        }
        if (this.state.rPref !== undefined && this.state.rPref !== null) {
            pref = this.state.rPref;
        }
        this.FbrService.generer_stat_rapportage_prest(spd1, spd2, region, pref,crd, format);
    }

    get_liste_data() {
        let spd1 = moment(this.state.pd1).format('MM/YYYY');
        let spd2 = moment(this.state.pd2).format('MM/YYYY');
        let region = 'Tous';
        let pref = 'Tous';
        let crd = 'Tous';
        if (this.state.rCrd !== undefined && this.state.rCrd !== null) {
            crd = this.state.rCrd;
        }
        if (this.state.rRegion !== undefined && this.state.rRegion !== null) {
            region = this.state.rRegion;
        }
        if (this.state.rPref !== undefined && this.state.rPref !== null) {
            pref = this.state.rPref;
        }
        this.setState({showindicator: true});
        this.FbrService.get_stat_rapportage_prest(spd1, spd2, region, pref,crd).then(data => this.setState({ liste_data: data,showindicator: false }));
    }

    componentDidMount() {
        this.FbrService.get_liste_prefecture().then(data => {
			if (data != null && data != undefined) {
                this.setState({liste_all_pref: data});
			} 
		});
        this.FbrService.get_liste_crd().then(data => {
			if (data != null && data != undefined) {
                this.setState({ liste_all_crd: data });
			} 
		});
        this.get_liste_data();
        this.setState({liste_region: this.FbrService.get_liste_regions()});
    }


    select_pref(region) {
        let liste = [];
        if (this.state.liste_all_pref != null && this.state.liste_all_pref != undefined) {
            if (this.state.liste_all_pref.length > 0) {
                let liste_filtre = this.state.liste_all_pref.filter(function (el) {
                    return el.region == region;
                });
                if (liste_filtre != null && liste_filtre != undefined) {
                    if (liste_filtre.length > 0) {
                        liste = liste_filtre.map(x => {
                            return { value: x.nom_pref, label: x.nom_pref }
                        });
                    }
                }
            }
        }
        this.setState({ liste_pref: liste });
    }

    select_crd(pref) {
        let liste = [];
        if (this.state.liste_all_crd != null && this.state.liste_all_crd != undefined) {
            if (this.state.liste_all_crd.length > 0) {
                let liste_filtre = this.state.liste_all_crd.filter(function (el) {
                    return el.nom_pref == pref;
                });
                if (liste_filtre != null && liste_filtre != undefined) {
                    if (liste_filtre.length > 0) {
                        liste = liste_filtre.map(x => {
                            return { value: x.nom_crd, label: x.nom_crd }
                        });
                    }
                }
            }
        }
        this.setState({ liste_crd: liste });
    }


    render() {
        return (
            <div className="card p-fluid">
                <div className="grid">
                    <div className="col-12">
                        <div className="card-w-title">
                            <i className="pi pi-search"></i> Option de recherche
                                    <hr />
                            <div className="grid">
                                <div className="col-12 md:col-2">
                                    <Calendar value={this.state.pd1} onChange={(e) => this.setState({ pd1: e.value }, () => {
                                        //this.get_liste_data();
                                    })} view="month" dateFormat="mm/yy" yearNavigator yearRange="2021:2070" />
                                </div>
                                <div className="col-12 md:col-2">
                                    <Calendar value={this.state.pd2} onChange={(e) => this.setState({ pd2: e.value }, () => {
                                       // this.get_liste_data();
                                    })} view="month" dateFormat="mm/yy" yearNavigator yearRange="2021:2070" />
                                </div>
                                <div className="col-12 md:col-2">
                                    <Dropdown autoWidth={false} options={[{ label: 'IRS', value: 'Tous' }].concat(this.state.liste_region)} optionLabel='label' placeholder='IRS' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.rRegion} onChange={e => this.setState({ rRegion: e.value }, () => {
                                       // this.get_liste_data();
                                        this.select_pref(e.value);
                                    })} />
                                </div>
                                <div className="col-12 md:col-2">
                                    <Dropdown autoWidth={false} options={[{ label: 'DPS', value: 'Tous' }].concat(this.state.liste_pref)} optionLabel='label' placeholder='DPS' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.rPref} onChange={e => this.setState({ rPref: e.value }, () => {
                                        //this.get_liste_data();
                                        this.setState({liste_crd: []});
                                        this.select_crd(e.value);
                                    })} />
                                </div>
                                <div className="col-12 md:col-2">
                                    <Dropdown autoWidth={false} options={[{ label: 'CR', value: 'Tous' }].concat(this.state.liste_crd)} optionLabel='label' placeholder='CR' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.rCrd} onChange={e => this.setState({ rCrd: e.value }, () => {
                                        //this.get_liste_data();
                                    })} />
                                </div>
                                <div className="col-12 md:col-2">
                                    <div className="inputgroup">
                                        {this.state.showindicator ? <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="4" fill="#EEEEEE" animationDuration=".5s" /> : 
                                        <SplitButton label="Rechercher" style={{ width: '140px' }} onClick={(e) => this.get_liste_data()} icon="pi pi-search" model={this.state.items}/>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DataTable value={this.state.liste_data} responsive={true} paginator={true} rows={20} paginatorPosition="top" alwaysShowPaginator={false}  csvSeparator=";" ref={(el) => { this.dt = el; }} className="p-datatable-gridlines p-datatable-striped p-datatable-md p-datatable-customers" >
                    <Column field="ordre" header="NO" style={{ width: '5%' }} filter={true} filterMatchMode='contains' />
                    <Column field="nomPrest" header="ACTEUR" filter={true} filterMatchMode='contains' sortable={true} />
                    <Column field="regionSite" header="IRS" filter={true} filterMatchMode='contains' sortable={true} style={{ width: '12%' }} />
                    <Column field="prefectureSite" header="DPS" filter={true} filterMatchMode='contains' sortable={true} style={{ width: '12%' }} />
                    {/* <Column field="crdSite" header="CR" filter={true} filterMatchMode='contains' sortable={true} style={{ width: '12%' }} /> */}
                    <Column field="nb_prev" header="PREVU" style={{ width: '10%' }} filter={true} filterMatchMode='contains' sortable={true} />
                    <Column field="nb" header="RAP" style={{ width: '8%' }} filter={true} filterMatchMode='contains' sortable={true} />
                    <Column field="taux_rp" body={(rowData, column) => {
                        return <div>
                            <span>{rowData.taux_rp} %</span>
                        </div>
                    }}  header="TAUX" style={{ width: '8%' }} filter={true} filterMatchMode='contains' sortable={true} />
                    <Column field="nb_val" header="VAL" style={{ width: '7%' }} filter={true} filterMatchMode='contains' sortable={true} />
                    <Column field="nb_ec" header="EC" style={{ width: '7%' }} filter={true} filterMatchMode='contains' sortable={true} />
                    <Column field="nb_pay" header="PAYE" style={{ width: '8%' }} filter={true} filterMatchMode='contains' sortable={true} />
                </DataTable>
            </div>
        );
    }
}